export const ApiEndPoints=(name:any)=> {
    var list: any ={
        getMe:"api/franchise/getMe",
        getOrder:"api/franchise/order",
        patchOrder:"api/franchise/order"
    };
    return list[name];
}